<template>
  <div class="columns is-marginless is-paddingless section section-details">
    <div class="column is-10 pdl-0 pdt-0">
      <div class="steps-detail">
        <dot-steps :steps="etatsContrat"
                   :current-step="contrat.etat"/>
      </div>
      <user-warning-message
        :users="[{
          id: contrat.responsableBailId,
          msg: 'utilisateur.warning.responsableBailArchive'
        }]"/>
      <div class="card" id="infoBail">
        <header class="header-card">
          <p>
            {{ $t('detailContrat.infoBail.title')}}
          </p>
        </header>
        <info-bail :contrat="contrat"></info-bail>
      </div>
      <div class="card mgt-20px">
        <header class="header-card">
          <p>
            {{ $t('detailContrat.renouvellement.title')}}
          </p>
        </header>
        <renouvellement-bail :contrat="contrat"></renouvellement-bail>
      </div>
      <div v-if="contrat.estIndexe" class="card mgt-20px" id="indexation">
        <header class="header-card">
          <p>
            {{ $t('detailContrat.indexation.title')}}
          </p>
        </header>
        <indexation :contrat="contrat"></indexation>
      </div>
      <contrepartie :contrat="contrat" :is-detail="true"
        class="mgt-20px" id="contrepartie"></contrepartie>
      <div class="card mgt-20px" id="comments">
        <header class="header-card">
          <p>
            {{ $t('detailContrat.commentaire.title')}}
          </p>
        </header>
        <commentaire :contrat="contrat"></commentaire>
      </div>
      <historique-commande class="mgt-20px"
                           :sens="sensAchat"
                           :historique="contrat.historique" :id="contrat.id"
                           :etats="listeEtatAvceTraduction"/>
      <div class="card mgt-20px" id="attachments">
        <header class="header-card">
          <p>
            {{ $t('detailContrat.pj.title')}}
          </p>
        </header>
        <div class="card-content">
          <app-pieces-jointes readOnly
                              deletable
                              autoSave
                              :checkPermissions=checkPermissions(permsContrat.maj)
          />
        </div>
      </div>
    </div>
    <div class="column is-2 pdt-0">
      <div class="is-fixed">
        <dots-menu :steps="steps">
        </dots-menu>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import infoBail from '@/components/baux/contrat/componentDetail/infoBail';
import indexation from '@/components/baux/contrat/componentDetail/indexation';
import commentaire from '@/components/baux/contrat/componentDetail/commentaire';
import DotsMenu from '@/components/general/dotsMenu';
import DotSteps from '@/components/general/dotSteps';
import PiecesJointes from '@/components/general/piecesJointes';
import { CONTRAT } from '@/configuration/baux/permissionsBauxConf';
import historiqueCommande from '@/components/general/historique';
import { SENS_ACHAT } from '@/configuration/devisConf';
import * as contratConf from '@/configuration/baux/contrat/contratConf';
import contrepartie from '@/components/baux/contrat/contrepartie';
import userWarningMessage from '@/components/commun/user/userWarningMessage';
import renouvellementBail from '@/components/baux/contrat/componentDetail/renouvellementBail';

const Permissions = createNamespacedHelpers('permissions');

export default {
  name: 'BauxContratDetailBail',
  props: {
    contrat: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      permsContrat: CONTRAT,
      sensAchat: SENS_ACHAT,
      etatsContrat: [
        contratConf.CONTRAT_ETAT_BROUILLON,
        contratConf.CONTRAT_ETAT_ENREGISTRE,
        contratConf.CONTRAT_ETAT_CLOS],
      listeEtatAvceTraduction: contratConf.LISTE_ETAT_CONTRAT,
    };
  },
  components: {
    infoBail,
    indexation,
    commentaire,
    DotSteps,
    DotsMenu,
    appPiecesJointes: PiecesJointes,
    historiqueCommande,
    contrepartie,
    userWarningMessage,
    renouvellementBail,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    steps() {
      return [
        {
          name: this.$i18n.t('detailContrat.steps.infoBail'),
          ref: '#infoBail',
          active: true,
        },
        {
          name: this.$i18n.t('detailContrat.steps.indexation'),
          ref: '#indexation',
          active: false,
          hidden: !this.contrat.estIndexe,
        },
        {
          name: this.$i18n.t('detailContrat.steps.contrepartie'),
          ref: '#contrepartie',
          active: false,
        },
        {
          name: this.$i18n.t('detailContrat.steps.commentaires'),
          ref: '#comments',
          active: false,
        },
        {
          name: this.$i18n.t('detailContrat.steps.piecesJointes'),
          ref: '#attachments',
          active: false,
        },
      ].filter(el => !el.hidden);
    },
  },
};

</script>
